import { render, staticRenderFns } from "./TableForm.vue?vue&type=template&id=5aaf36ad&scoped=true"
import script from "./TableForm.vue?vue&type=script&lang=js"
export * from "./TableForm.vue?vue&type=script&lang=js"
import style0 from "./TableForm.vue?vue&type=style&index=0&id=5aaf36ad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaf36ad",
  null
  
)

export default component.exports